import { scrollToElement } from '@project/shared/utils/scroll-to/js/scroll-to';

/**
 * This script handles generic hashscrolling
 */

let initialized: boolean = false;
/**
 * Initializes Hashscrolling
 *
 */
export function init(): void {
	if (!initialized) {
		initialized = true;
		if (window.location.hash.length > 1) {
			setTimeout(() => {
				scrollToIdElement(window.location.hash);
			}, 1000);
		}
		$(window).on('hashchange.hashscrolling', () => {
			scrollToIdElement(window.location.hash);
		});
	}
}

export function addScrollClickTrigger($el: JQuery) {
	$el.on('click.hashscrolling', (ev: JQuery.Event) => {
		ev.preventDefault();
		const hash = (ev.currentTarget as any).hash;
		historyPush(hash);
		scrollToIdElement(hash);
	});
}

function scrollToIdElement(hash: string) {
	const $el = $(document.getElementById(hash.substring(1)));
	if ($el.length === 1) {
		if ($('.js-m-navigation-in-page__wrapper').length > 0) {
			scrollToElement($el, true, $('.js-m-navigation-in-page__wrapper').height() + 20 || 120, true);
		} else {
			scrollToElement($el, true, $('.js-o-header-wrapper').height() || 120, true);
		}
	}
}

function historyPush(hash: string): any {
	if (history.pushState) {
		const newurl =
			window.location.protocol +
			'//' +
			window.location.host +
			window.location.pathname +
			window.location.search +
			hash;
		window.history.pushState({ path: newurl }, '', newurl);
	}
}
